import React, { useEffect, useState } from 'react';

const InformationSection = () => {
  const [typedText, setTypedText] = useState('');
  const keyPoints = [
    "Web Development",
    "Machine Learning",
    "Artificial Intelligence",
    "Cybersecurity"
  ];
  const typingSpeed = 100; // Typing speed in milliseconds

  useEffect(() => {
    let currentText = '';
    let currentIndex = 0;

    const intervalId = setInterval(() => {
      if (currentIndex < keyPoints.length) {
        const nextChar = keyPoints[currentIndex][currentText.length];
        currentText += nextChar;
        setTypedText(currentText);
        if (currentText === keyPoints[currentIndex]) {
          currentIndex++;
          currentText = '';
        }
      } else {
        clearInterval(intervalId);
      }
    }, typingSpeed);

    return () => clearInterval(intervalId);
  }, []); // Run effect only once

  return (
    <div className="font-sans text-xl text-gray-800 flex justify-items-start mt-16">
      <div className="bg-white rounded-lg shadow-md p-5 mr-8">
        <p className="mb-4">Hello 👋 Everyone, I'm <span className="font-bold">RamMohan</span>!</p>
        <p className="mb-4">I am an <span className="italic">Engineering Student/Developer</span> and a <span className="underline">Tech Enthusiast</span>.</p>
        <p className="mb-4">I'm currently in my <span className="italic">3rd Year</span> of <span className="font-semibold">B.Tech</span> at <span className="text-blue-700">A P J KALAM UNIVERSITY</span>.</p>
        <p>My interests include {typedText && <span className="text-red-600">{typedText}</span>}<span className="cursor">&nbsp;</span></p>
      </div>
    </div>
  );
};

export default InformationSection;
